
  import { Component, Vue } from 'vue-property-decorator'
  import { HEIGHT_CALC } from '@/utils/general'

@Component
  export default class GeneralLoading extends Vue {
  calc = HEIGHT_CALC;
  }
